export default {
  Title: {
    Username : 'Πληκτρολογήστε το όνομα χρήστη σας',
    PinPass  : 'Πληκτρολογήστε το προσωπικό σας PIN',
    Terms    : 'Αποδεχτείτε τους Όρους και τις Προϋποθέσεις',
    AdminPass: 'Πληκτρολογήστε κωδικό διαχειριστή'
  },
  Field: {
    Username: {
      Label: 'Όνομα χρήστη',
      Hint : 'Email ή UID',
      Icon : 'person_pin',
      Error: {
        Empty: 'Συμπληρώστε όνομα χρήστη',
        Min  : 'Το όνομα χρήστη πρέπει να είναι τουλάχιστον 8 χαρακτήρες'
      }
    },
    AdminPass: {
      Label: 'Κωδικός διαχειριστή',
      Icon : 'password'
    },
    RememberMe: {
      Label: 'Να με θυμάσαι'
    },
    Result: {
      WrongUsernamePin: 'Λάθος όνομα χρήστη ή PIN',
      WrongPin        : 'Λάθος Κωδικός PIN',
      WrongPassword   : 'Λάθος Κωδικός'
    },
    Terms: {
      Title: 'Όροι Χρήσης & Παροχής Υπηρεσιών',
      Body : `<p>Η χρήση των υπηρεσιών του Getfood Pro συνεπάγεται την πλήρη και ανεπιφύλακτη αποδοχή των <span class="gfp-terms-link"><a href="https://terms.getfoodpro.com/" target="_blank" >Όρων Χρήσης και Παροχής Υπηρεσιών</a></span> του Getfood Pro.</p>`
    }
  },
  StaffGroup: {
    11 : 'Super Admin',
    12 : 'GFP Editor',
    13 : 'CRM Editor',
    100: 'Ιδιοκτήτης',
    101: 'Ταμίας',
    102: 'Σερβιτόρος',
    103: 'Χρήστης',
    104: 'Διανομέας'
  }
}
